import React, { useEffect, useState } from 'react';
import './Certificate.css'
import PlusSquared from '../../Images/PlusSquared.svg'
import FolderSvg from '../../Images/folder.svg'
import axios from 'axios';
import { MAIN_URL } from '../../constants';
import { toast } from 'react-toastify';
import api from '../../Components/RefreshToken/RefreshToken';

const Certificate = () => {
    const TOKEN = localStorage.getItem("admin_token")
    const [fileName, setFileName] = useState('');
    const [fileURL, setFileURL] = useState('');
    const [loading, setLoading] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [formData, setFormData] = useState({
        text: '',
        file: null
    })
    const [certificates, setCertificates] = useState()
    const [certificateName, setCertificateName] = useState()
    const [deletedIsOpen, setDeletedIsopen] = useState(false)


    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFileName(file.name);
            setFormData(prev => ({
                ...prev,
                file: file
            }));
        }
    };

    const handleOpen = () => {
        setIsModalOpen(x => !x)
    }

    useEffect(() => {
        axios.get(`${MAIN_URL}/management/certificates`, {
            headers: {
                "Content-Type": "application/json"
            },
        }).then((res) => {
            console.log(res.data)
            setCertificates(res?.data)
        }).catch((err) => {
            console.log(err);

        })
    }, [isModalOpen, deletedIsOpen])

    const addCertificate = () => {
        const formDat = new FormData()
        if (formData.file) {
            formDat.append("file", formData?.file)
        }
        api.post(`/management/certificates`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": `Bearer ${TOKEN}`
            },
        }).then((res) => {
            console.log(res);
            setIsModalOpen(false)
            toast.success("Certificate added successfully")
            setFormData("")
            setFileName("")
        }).catch((error) => {
            console.log(error);

        })
    }

    const deleteCertificate = () => {
        api.delete(`/management/certificates/${certificateName}`,{
            headers: {
                Authorization: `Bearer ${TOKEN}`
            }
        }).then((res) => {
            console.log(res);
            toast.success("Certificate deleted successfully")
            setDeletedIsopen(false)
        }).catch((err) => {
            console.log(err);
        })
    }

    const handleDeleted = () => {
        setDeletedIsopen(x=>!x)
        console.log("bosildi", deletedIsOpen)
    }

    // console.log("certifikatlar listi", certificates);
    // console.log("certifikatlar name", certificateName);


    return (
        <div>
            <div className="certificate-title">
                <h1 className='confirm-lesson-title'>Certificate</h1>
                <button onClick={handleOpen} className='icon-div add-certificate'>Add Certificate</button>
            </div>
            <div className="certificate-block">
                {certificates?.certificates?.map((item, i) => (
                    <div key={i} className="certificate-card">
                        <img className='certificate-img' src={item?.url} alt="certificate image" />
                        <div className="delete-certificate">
                            <i onClick={(e) => { setCertificateName(item?.filename); handleDeleted() }} className="ri-delete-bin-fill delete-cer"></i>
                        </div>
                    </div>
                ))}
            </div>
            {isModalOpen && (
                <div className="add-certificate-input"
                    style={{ marginBottom: "0px", width: "100%", }}>
                    <div className="certificate-modal">
                        <h3>Added Certificate:</h3>
                        <label className="add-file certificate-label">
                            <span>Add file</span>
                            <img src={PlusSquared} alt="" />
                            <input
                                required
                                type="file"
                                name="image/*"
                                accept="image/*"
                                style={{ display: "none" }}
                                onChange={handleFileChange}
                            />
                        </label>

                        {fileName && (
                            <div className='uploaded-file-container certificate-file'>
                                <img src={FolderSvg} alt="" />
                                <a target="_blank" rel="noopener noreferrer">
                                    {fileName.length > 12 ? fileName.slice(0, 12) + "..." : fileName}
                                </a>
                            </div>
                        )}

                        <div className="form-modal-footer certificate-btn">
                            <button onClick={handleOpen} className="form-cancel-btn">
                                Cancel
                            </button>
                            <button onClick={addCertificate} className="form-confirm-btn" disabled={loading} >
                                {loading ? "Loading..." : "Added"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {deletedIsOpen && (
                <div className="delete-modal">
                    <div className="delete-block">
                        <h4>Are you sure you want to delete?</h4>
                        <div className="certificate-btn deleted-btn">
                            <button onClick={handleDeleted} className="form-cancel-btn delete-btn">Cancel</button>
                            <button onClick={deleteCertificate} className="form-confirm-btn delete-btn">OK</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default Certificate;
